import { render, staticRenderFns } from "./PagesTable.vue?vue&type=template&id=eafdaeb2&"
import script from "./PagesTable.vue?vue&type=script&lang=js&"
export * from "./PagesTable.vue?vue&type=script&lang=js&"
import style0 from "./PagesTable.vue?vue&type=style&index=0&id=eafdaeb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports